globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { useCallback, useMemo } from 'react';
import differenceInDays from 'date-fns/differenceInDays';
import { useTranslation } from 'react-i18next';
import { EmployerCandidateCard, EmployerCandidateCardHeader, EmployerCandidateCardInfo, EmployerCandidatesCardLabels } from './employer-candidate-card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmployerCandidateKanbanCard(_ref) {
  var candidate = _ref.candidate,
      ctaButton = _ref.ctaButton,
      distance = _ref.distance,
      labels = _ref.labels,
      lastStatusChangeDate = _ref.lastStatusChangeDate,
      wrapperStyle = _ref.wrapperStyle,
      statusKey = _ref.statusKey;

  var _useCandidateLastChan = useCandidateLastChangeBadgeInfo(),
      getCandidateLastChangeBadgeInfo = _useCandidateLastChan.getCandidateLastChangeBadgeInfo;

  var _useMemo = useMemo(function () {
    return getCandidateLastChangeBadgeInfo(lastStatusChangeDate, statusKey);
  }, [getCandidateLastChangeBadgeInfo, lastStatusChangeDate, statusKey]),
      badgeVariant = _useMemo.badgeVariant,
      badgeText = _useMemo.badgeText;

  var badge = useMemo(function () {
    return {
      variant: badgeVariant,
      text: badgeText
    };
  }, [badgeText, badgeVariant]);
  var currrentCta = useMemo(function () {
    return {
      label: ctaButton.label,
      onClick: ctaButton.onClick
    };
  }, [ctaButton.label, ctaButton.onClick]);
  return /*#__PURE__*/_jsxs(EmployerCandidateCard, {
    ctaButton: currrentCta,
    twStyle: wrapperStyle,
    children: [/*#__PURE__*/_jsx(EmployerCandidateCardHeader, {
      firstName: candidate.firstName,
      lastName: candidate.lastName
    }), /*#__PURE__*/_jsx(EmployerCandidateCardInfo, {
      candidateImage: candidate.image,
      badge: badge,
      distance: distance
    }), /*#__PURE__*/_jsx(EmployerCandidatesCardLabels, {
      labels: labels.values,
      variant: "neutral"
    })]
  });
}
export default EmployerCandidateKanbanCard;
export function useCandidateLastChangeBadgeInfo() {
  var _useTranslation = useTranslation('common'),
      translateCommon = _useTranslation.t;

  var getCandidateLastChangeBadgeInfo = useCallback(function (lastStatusChangeDate, statusKey) {
    var daysSinceChange = differenceInDays(new Date(), new Date(lastStatusChangeDate));
    var badgeVariant;
    var badgeText;

    if (statusKey === 'worker_jp_in_shortlist') {
      badgeVariant = 'fresh';
      badgeText = translateCommon('new');
    } else if (daysSinceChange === 0) {
      badgeVariant = 'success';
      badgeText = translateCommon('today');
    } else {
      badgeVariant = daysSinceChange <= 3 ? 'warning' : 'danger';
      badgeText = daysSinceChange > 1 ? "".concat(daysSinceChange, " ").concat(translateCommon('days_ago')) : "".concat(daysSinceChange, " ").concat(translateCommon('day_ago'));
    }

    return {
      badgeVariant: badgeVariant,
      badgeText: badgeText
    };
  }, [translateCommon]);
  return {
    getCandidateLastChangeBadgeInfo: getCandidateLastChangeBadgeInfo
  };
}